import{__require as r}from"./build_distance_in_words_locale/index.js";import{__require as e}from"./build_format_locale/index.js";var i,o;function _(){if(o)return i;o=1;var _=r(),a=e();return i={distanceInWords:_(),format:a()}}export{_ as __require};
//# sourceMappingURL=index.js.map
